const music = [
    {'src': '/music/MA_EvgenyMartinov_SummerMidnight_Main.mp3'},
    {'src': '/music/MA_Polytunes_YourGentleSmile.mp3'},
    {'src': '/music/MA_Stories_in_Sound_Studios.mp3'},
  ];

  export default music;